module.exports = __webpack_public_path__ + "img/PLASTIC.0145afaa.jpeg";